import { takeEvery } from 'redux-saga/effects'

import { REQUEST_SUCCESS, REQUEST_ERROR } from '@piconetworks/network-middleware'

import Auth from 'common/modules/auth'
import Plan from 'common/modules/plan'
import Loader from 'common/modules/loader'
import Zoid from 'common/modules/zoid'

import {
    watchCreateFrame,
    watchDestroyFrame,
    watchHideFrame,
    watchInitFrame,
    watchShowFrame,
    watchToggleFrame,
} from './frames'
import watchLoaderActions from './loaderActions'
import {
    watchNetworkRequestError,
    watchNetworkRequestSuccess,
} from './network'
import {
    watchRemoveAccessToken,
    watchRemoveRefreshToken,
    watchStoreAccessToken,
    watchStoreRefreshToken,
    watchUpdateToken,
} from './tokens'

import watchZoidInit from './zoidInit'
import watchPicoReady from './picoReady'
import { watchLoaderRequest, watchLoaderSuccess, watchLoaderError } from './loader'
import watchDirectLinks from './directLinks'
import watchLogout from './logout'
import watchFrameSubmit from './frameSubmit'
import watchDirectPlanLink from './directPlanLink'

import watchUserAuthenticated from './userAuthenticated'
import watchPlanPurchased from './planPurchased'
import watchInvalidationEvent from './invalidationEvent'
import watchLinkPassed from './linkPassed'
import watchPurchaseArticle from './purchaseArticle'

import watchSendAppError from './sendAppError'
import closePico from './closePico'

import { types } from '../actions'

export function* takes({ dispatch, getState }) {
    yield takeEvery(Zoid.types.ZOID_INIT_SUCCESS, watchZoidInit)

    yield takeEvery(types.PICO_READY, watchPicoReady)
    yield takeEvery(types.PICO_INIT, watchLoaderActions, { dispatch, getState })

    yield takeEvery(Loader.types.GET_LOADER, watchLoaderRequest)
    yield takeEvery(Loader.types.GET_LOADER_SUCCESS, watchLoaderSuccess)
    yield takeEvery(Loader.types.GET_LOADER_ERROR, watchLoaderError)
    yield takeEvery(Loader.types.UPDATE_LOADER_PRICING_MONETIZATION_TIERS, watchLoaderSuccess)
    yield takeEvery(Loader.types.UPDATE_LOADER_USER_NEWSLETTERS, watchLoaderSuccess)

    yield takeEvery(types.INVALIDATION_EVENT, watchInvalidationEvent)

    yield takeEvery(REQUEST_SUCCESS, watchNetworkRequestSuccess)
    yield takeEvery(REQUEST_ERROR, watchNetworkRequestError)

    yield takeEvery(types.UPDATE_TOKENS, watchUpdateToken)
    yield takeEvery(types.STORE_REFRESH_TOKEN, watchStoreRefreshToken)
    yield takeEvery(types.STORE_ACCESS_TOKEN, watchStoreAccessToken)
    yield takeEvery(types.REMOVE_REFRESH_TOKEN, watchRemoveRefreshToken)
    yield takeEvery(types.REMOVE_ACCESS_TOKEN, watchRemoveAccessToken)

    yield takeEvery(types.FRAME_INIT, watchInitFrame)
    yield takeEvery(types.FRAME_LINK, watchDirectLinks)
    yield takeEvery(types.FRAME_HIDE, watchHideFrame)
    yield takeEvery(types.FRAME_SHOW, watchShowFrame)
    yield takeEvery(types.FRAME_CREATE, watchCreateFrame)
    yield takeEvery(types.FRAME_TOGGLE, watchToggleFrame)
    yield takeEvery(types.FRAME_DESTROY, watchDestroyFrame)
    yield takeEvery(types.FRAME_SUBMIT, watchFrameSubmit)
    yield takeEvery(types.FRAME_PLAN_LINK, watchDirectPlanLink)

    yield takeEvery('AUTH/LOGOUT', watchLogout)

    yield takeEvery(Auth.types.TOKEN_LOGIN, watchUpdateToken)

    yield takeEvery(Plan.types.PURCHASE_PLAN_SUCCESS, watchPlanPurchased)

    yield takeEvery(Auth.types.LOGIN_SUCCESS, watchUserAuthenticated)
    yield takeEvery(Auth.types.SOCIAL_LOGIN_SUCCESS, watchUserAuthenticated)
    yield takeEvery(Auth.types.CLAIM_MAGIC_LINK_SUCCESS, watchUserAuthenticated)

    yield takeEvery(types.SEND_EXTERNAL_LINK, watchLinkPassed)

    yield takeEvery(types.SEND_APP_ERROR, watchSendAppError)
    yield takeEvery(types.PURCHASE_ARTICLE, watchPurchaseArticle)

    yield takeEvery(types.CLOSE_PICO, closePico)
}

const sagas = {
    takes,
}

export default sagas
